module.exports = __webpack_public_path__ + "assets/retina_T3_PointDetailed.b9ff95655543f4150fba166736c0fd7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_T3_PointDetailed.png
// module id = 728
// module chunks = 0